module.exports = __webpack_public_path__ + "static/media/data_5.88a60898.mp4";